<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-wrap">
          <div-title
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
            :colorP="colorP"
          >
            Actualización del título
          </div-title>

          <div class="flex flex-col w-full pl-4">
            <form class="w-full max-w-lg" id="RaisingTitleForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3 mb-3">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="title"
                    >Titulo *</label
                  >
                  <input
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="title"
                    type="text"
                    name="title"
                    v-model="title"
                  />
                  <p
                    v-if="errors.title"
                    class="text-red-500 text-xs italic text-left"
                  >
                    Escriba un titulo.
                  </p>
                </div>
              </div>

              <!-- <div class="w-full mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="select_proyect"
                  >Lista de proyectos</label
                >
                <div class="relative">
                  <select
                    v-model="select_proyect"
                    name="select_proyect"
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  >
                    <option value=null>Ningun proyecto</option>
                    <template
                      v-for="(
                        option, optId
                      ) in listProyects"
                    >
                      <option :key="optId.id" :value="option.id">
                        {{ option.nombre }}
                      </option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
              </div> -->

              <div class="flex w-full justify-end">
                <btn-action
                  class="px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveTitleRaising()"
                  :colorT="colorT"
                >
                  Guardar
                </btn-action>
                <button
                  class="ml-2 bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Actualización del título exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{ errors.codeError }}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";
import moment from "moment";

import { styled } from "@egoist/vue-emotion";

const DivTitle = styled("div")`
  color: ${(props) => props.colorP};
`;

const BtnAction = styled("button")`
  background-color: ${(props) => props.colorT};
`;

export default {
  name: "user-raising-update-title-modal",
  data() {
    return {
      title: null,
      information: null,
      errors: {
        title: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      select_proyect: null,
      listProyects: null,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    colorP: {
      required: true,
    },
    colorS: {
      required: true,
    },
    colorT: {
      required: true,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
    EventBus.$on("updateTitle", this.setData);
  },
  components: {
    AlertDialog,
    DivTitle,
    BtnAction,
  },
  methods: {
    reset: function () {
      (this.select_proyect = null),
        (this.listProyects = null),
        (this.title = null),
        (this.information = null);
      this.errors = {
        title: false,
        codeError: "Ha ocurrido un error",
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    setData(data) {
      this.fetchAllProyects();
      this.information = Object.assign({}, data);
      this.title = this.information.title;
      this.select_proyect = this.information.select_proyect;
    },

    fetchAllProyects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/projects/getAllProjectsList",
          {
            activos: true,
          },
          this.config
        )
        .then((response) => {
          this.listProyects = response.data.proyectos;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = true;
        });
    },

    saveTitleRaising() {
      const form = document.getElementById("RaisingTitleForm");
      const signInData = new FormData(form);
      const validForm = this.checkFormSelectAuthority(signInData);

      if (validForm) {
        this.$root.$emit("showLoading");
        this.axios
          .put(
            `apidev/levantamientos/updateTitulo/${this.information.raising_id}`,
            {
              title: this.title,
              project_id: this.select_proyect,
            },
            this.config
          )
          .then(() => {
            this.$root.$emit("hideLoading");
            this.showingSuccess = true;
            this.$emit("updateTitle", {
              title: this.title,
              id_proyecto: this.select_proyect,
            });
            this.close();
          })
          .catch((error) => {
            this.catchError(error);
            this.showingError = true;
          });
      }
    },

    checkFormSelectAuthority: function (signInData) {
      this.errors.title = signInData.get("title").trim() === "" ? true : false;
      return this.errors.title ? false : true;
    },

    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
